import type { SVGProps } from "react";
export interface LayersIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LayersIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LayersIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.668 16.091a1.125 1.125 0 0 1 1.484-.572 1.614 1.614 0 0 1 0 2.962l-7.343 3.262a4.47 4.47 0 0 1-3.4.09l-.218-.09-7.344-3.262a1.614 1.614 0 0 1 0-2.962l.107-.041a1.125 1.125 0 0 1 1.46 1.236l6.69 2.972.218.082a2.22 2.22 0 0 0 1.573-.082l6.69-2.972a1.1 1.1 0 0 1 .083-.622Zm.826.907-.255.577.458-1.028zm-.826-5.908a1.125 1.125 0 0 1 1.484-.57 1.614 1.614 0 0 1 0 2.961l-7.343 3.262a4.47 4.47 0 0 1-3.4.09l-.218-.09-7.344-3.262a1.614 1.614 0 0 1 0-2.962l.107-.04a1.125 1.125 0 0 1 1.46 1.236l6.69 2.972.218.082a2.22 2.22 0 0 0 1.573-.082l6.69-2.972a1.1 1.1 0 0 1 .083-.624Zm.826.909-.255.577.458-1.028-.203.45Z"
      />
      <path
        fill={color}
        d="M10.409 2.168a4.47 4.47 0 0 1 3.4.09l7.343 3.262.229.121a1.612 1.612 0 0 1-.229 2.84l-7.343 3.261a4.47 4.47 0 0 1-3.618 0L2.847 8.48a1.613 1.613 0 0 1 0-2.96l7.344-3.262zm2.486 2.146a2.22 2.22 0 0 0-1.573-.083l-.217.083L5.056 7l6.049 2.687.217.083a2.22 2.22 0 0 0 1.573-.083L18.942 7z"
      />
    </svg>
  );
}
